import React from "react";

function escapeRegExp(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/** Разбивает поисковый запрос на слова тем же способом, что и бэкенд search.util.ts */
function tokenize(term: string): string[] {
  return term
    .toLowerCase()
    .trim()
    .replace(/[/\-_.,()]+/g, " ")
    .split(/\s+/)
    .filter(Boolean);
}

interface HighlightTextProps {
  text: string | number | null | undefined;
  search?: string;
}

/** Подсвечивает вхождения слов из поискового запроса в тексте (без учёта регистра/разделителей). */
export default function HighlightText({ text, search }: HighlightTextProps) {
  const value = text === null || text === undefined ? "" : String(text);
  const tokens = search ? tokenize(search) : [];

  if (tokens.length === 0) {
    return <>{value}</>;
  }

  const pattern = new RegExp(`(${tokens.map(escapeRegExp).join("|")})`, "gi");
  // При split() с одной захватывающей группой совпадения оказываются на
  // нечётных индексах результата, остальное — обычный текст между ними.
  const parts = value.split(pattern);

  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <mark key={i} style={{ padding: 0, backgroundColor: "#ffe58f" }}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </>
  );
}
